import React from "react";

const TAG_COLORS = {
  Email: { bg: "#F1F1EF", text: "#787774" },
  Call: { bg: "#DDEDEA", text: "#2B8A3E" },
  Pay: { bg: "#EEE0DA", text: "#8C5B3F" },
  Schedule: { bg: "#EAE4F2", text: "#6940A5" },
  "Sign Up": { bg: "#FBF3DB", text: "#9F6B00" },
};

function TagPills({ tags }) {
  if (!tags || tags.length === 0) return null;
  return tags.map(t => {
    const c = TAG_COLORS[t] || { bg: "var(--cream-hover)", text: "var(--muted)" };
    return (
      <React.Fragment key={t}>
        <span className="meta-dot" />
        <span style={{ fontSize: 11, fontWeight: 700, padding: "1px 7px", borderRadius: 20, background: c.bg, color: c.text }}>{t}</span>
      </React.Fragment>
    );
  });
}

function formatDate(dateStr) {
  if (!dateStr) return { label: "No due date", soon: false };
  const today = new Date();
  const date = new Date(dateStr + "T00:00:00");
  const diffDays = Math.ceil((date - today) / (1000 * 60 * 60 * 24));
  if (diffDays < 0) return { label: dateStr, soon: true };
  if (diffDays === 0) return { label: "Today", soon: true };
  if (diffDays === 1) return { label: "Tomorrow", soon: true };
  if (diffDays <= 7) return { label: date.toLocaleDateString("en-US", { month: "short", day: "numeric" }), soon: true };
  return { label: date.toLocaleDateString("en-US", { month: "short", day: "numeric" }), soon: false };
}

function SkeletonRow() {
  return (
    <div style={{ display: "flex", gap: 12, padding: "14px 20px", borderBottom: "1px solid var(--border)", alignItems: "flex-start" }}>
      <div className="skeleton" style={{ width: 28, height: 28, borderRadius: "50%", flexShrink: 0 }} />
      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>
        <div className="skeleton skeleton-line-long" style={{ height: 15 }} />
        <div className="skeleton skeleton-line-short" style={{ height: 12 }} />
      </div>
    </div>
  );
}

export default function RemindersSection({ items, loading, onSeeAll }) {
  return (
    <>
      <div className="section-head">
        <span className="section-label">Reminders</span>
      </div>
      <div style={{ background: "var(--white)", borderTop: "1px solid var(--border)" }}>
        {loading ? <SkeletonRow /> : items.length === 0 ? (
          <div className="empty-state"><div className="empty-text">No reminders</div></div>
        ) : items.slice(0, 3).map(item => {
          const d = formatDate(item.dueDate);
          return (
            <div key={item.id} className="task-row">
              <div style={{ width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <div style={{ width: 9, height: 9, borderRadius: "50%", background: "var(--sage)" }} />
              </div>
              <div className="task-content">
                <div className="task-name">{item.name}</div>
                <div className="task-sub">
                  <span className={`task-date${d.soon ? " soon" : ""}`}>{d.label}</span>
                  <TagPills tags={item.tag} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div onClick={onSeeAll} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 20px", background: "var(--cream-hover)", borderTop: "1px solid var(--border)", cursor: "pointer" }}>
        <span style={{ fontSize: 13, fontWeight: 700, color: "var(--sage)" }}>See all reminders</span>
        <span style={{ fontSize: 16, color: "var(--sage)" }}>›</span>
      </div>
    </>
  );
}
